import { FC } from "react"
import { ChangePassword } from "../../../module/users/containers/changePassword"

export const ChangePasswordPage: FC = () => <ChangePassword />
